if(typeof validator === 'undefined') {var e = new Error("Cannot find module 'validator'"); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = validator;